import { debounce } from "lodash";
import { useCallback, useEffect } from "react";
import { DEBOUNCE_DELAY } from "../../types/constant";

export const useDebouncedCallback = (callback: any) => {
  const debouncedCallback = useCallback(debounce(callback, DEBOUNCE_DELAY), [
    callback,
  ]);

  useEffect(() => {
    return debouncedCallback.cancel;
  }, [debouncedCallback]);

  return debouncedCallback;
};
